/*eslint-disable*/
import React from 'react';
export interface IGrantDetailsContext {
  tabValue?: number;
  setTabValue?: React.Dispatch<React.SetStateAction<number>>;
}

export const GrantDetailsContext = React.createContext<IGrantDetailsContext>({});
